import { gsap } from 'gsap';

const openAccordion = (accordion) => {
  const accordionContent = accordion.querySelector('.specs-accordion__content');

  gsap.to(accordionContent, {
    height: 'auto',
    duration: 0.2,
    onStart() {
      accordion.classList.add('specs-accordion--expanded');
    },
  });
};
const closeAccordion = (accordion) => {
  const accordionContent = accordion.querySelector('.specs-accordion__content');

  gsap.to(accordionContent, {
    height: 0,
    duration: 0.2,
    onStart() {
      accordion.classList.remove('specs-accordion--expanded');
    },
  });
};
const toggleAccordion = (accordion) => {
  if (accordion.classList.contains('specs-accordion--expanded')) {
    closeAccordion(accordion);
  } else {
    openAccordion(accordion);
  }
};
const initAccordion = (accordion, open = false) => {
  if (open) {
    openAccordion(accordion);
  }

  // Event listener for toggling accordion expansion.
  accordion.querySelector('.specs-accordion__header').addEventListener('click', (e) => {
    e.preventDefault();
    toggleAccordion(accordion);
  });
};

// Find the accordions
const accordions = document.querySelectorAll('.specs-accordion');
Array.from(accordions).forEach((accordion, index) => {
  initAccordion(accordion, index === 0);
});
